import React, { useEffect, useState } from 'react'
import { Wrapper } from './style'
import { MakeApiCall } from '../../../../apis';
import { message, Drawer, Descriptions, Collapse } from 'antd';
import ItemMaster from '../item-list';

const { Panel } = Collapse;

const Tiles = ({ userData, selectedMarketplace, selectedCurrencySign, selectedValue, customRange }) => {

  console.log(selectedMarketplace,selectedValue,  customRange.formatted?.start_date);
  
  const [loading, setLoading] = useState(true);
  const [tilesList, setTilesList] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedTileData, setSelectedTileData] = useState(null);

  // const [selectedTileData, setSelectedTileData] = useState(null);

  const fetchTilesDetails = async () => {
    const trialExpiredLocal = !!(userData?.user?.user_data?.trial_expires_at && Date.now() > parseInt(userData.user.user_data.trial_expires_at, 10) * 1000);
    if (!selectedMarketplace?.id || trialExpiredLocal) { setLoading(false); setTilesList([]); return; }
    setLoading(true);
    try {
      const response = await MakeApiCall(
        `dashboard/tiles/get-cards-data?marketplace_id=${selectedMarketplace?.id}&date_filter=${selectedValue}&start_date=${customRange.formatted?.start_date}&end_date=${customRange.formatted?.end_date}`,
        'get',
        null,
        true,
        {},
        userData?.token
      );
      if (response?.status) {
        setTilesList(response?.data || []);
      } else {
        message.warning(response?.message || "Failed to load");
      }
    } catch (error) {
      message.error('Error fetching.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedValue === 'custom') {
      // Only fetch when custom range dates are available
      if (customRange.formatted?.start_date && customRange.formatted?.end_date) {
        fetchTilesDetails();
      }
    } else if (selectedValue) {
      // For non-custom selections
      fetchTilesDetails();
    }
  }, [selectedMarketplace, selectedValue, customRange]);

  const showDrawer = (tile) => {
    setSelectedTileData(tile);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    // setSelectedTileData(null);
  };

  const formatNumber = (value) => {
    if (value == null) return '-'; // handle null/undefined
    const num = parseFloat(value);
    return num % 1 === 0 ? num : num.toFixed(0); // show 2 decimals only if needed
  };

  const renderRow = (label, value, bold = false, currencySign='') => (
    <>
     <div className="d-flex justify-content-between w-100 mb-2">
     <span className="text-gray-800 fw-normal text-hover-danger fs-7 ps-3 text-capitalize">
     {label}
     </span>
     <span className="text-gray-800 fw-bolder fs-7 me-0 gotham_black">
     {typeof value === 'number' ? `${currencySign}${value.toFixed(2)}` : value}
     </span>
   </div>
   </>
  );
  const renderNumberRow = (label, value, bold = false, currencySign='') => (
    <>
     <div className="d-flex justify-content-between w-100 mb-2">
     <span className="text-gray-800 fw-normal text-hover-danger fs-7 ps-3 text-capitalize">
     {label}
     </span>
     <span className="text-gray-800 fw-bolder fs-7 me-0 gotham_black">
     {typeof value === 'number' ? `${currencySign}${value.toFixed(0)}` : value}
     </span>
   </div>
   </>
  );

  const renderMainRow = (label, value, bold = false,  currencySign='') => (
    <>
     <div className="d-flex justify-content-between py-1 w-100 mb-2">
     <span className="text-gray-800 fw-normal fw-bold ps-8" style={{ fontSize: '14px' }}>
     {label}
     </span>
     <span className="text-gray-800 fw-bolder fs-7 me-0 gotham_black">
     {typeof value === 'number' ? `${currencySign}${value.toFixed(2)}` : value}
     </span>
   </div>
   </>
  );

  console.log(selectedTileData);

   // Function to only store data
   const storeTileData = (tile) => {
    console.log('Storing tile data:', tile);
    setSelectedTileData(tile);
    // Optional: Store in localStorage
    // localStorage.setItem('selectedTileData', JSON.stringify(tile));
  };

  return (
    <Wrapper>
      <div className="row gy-5 g-xl-5 mb-0">
        {tilesList.map((tile, index) => {
          const {
            filter_name,
            start_date,
            sales,
            orders,
            units,
            refunds,
            adv_cost,
            est_payout,
            more_data,
            net_profit,
            more_data: { gross_profit } = {}
          } = tile;

          return (
            <div  key={index} className="col-xxl-3 col-sm-6 mb-0">
              <div
               onClick={(e) => {
                e.preventDefault();
                storeTileData(tile);
              }} 
              style={{cursor: 'pointer'}}
               className="card card-xxl-stretch mb-5 mb-xl-8">
                <div className="card-header px-4 align-items-center border-bottom-dashed" style={{ backgroundColor: '#355070' }}>
                  <div>
                    <p className="mb-0 text-gray-300 mb-1">{filter_name}</p>
                    <h4 className="mb-0 text-gray-100">{new Date(start_date).toLocaleDateString()}</h4>
                  </div>
                </div>
                <div className="card-body px-4 pt-3 pb-2">
                  <div>
                    <p className="mb-0 text-gray-700 mb-1">Sales</p>
                    <h3 className="mb-0 text-gray-800">{selectedCurrencySign}{sales.toFixed(2)}</h3>
                  </div>
                  <div className="separator separator-dashed my-2" />
                  <div className="d-flex justify-content-between">
                    <div>
                      <div className="d-flex justify-content-start flex-column">
                        <span className="text-gray-700 fw-bold mb-1 fs-7">Orders/Units</span>
                        <span className="text-gray-800 fw-bolder d-block fs-4">{orders}/{units}</span>
                      </div>
                    </div>
                    <div>
                      <div className="d-flex justify-content-start flex-column">
                        <span className="text-gray-700 fw-bold mb-1 fs-7">Refunds</span>
                        <span className="text-gray-800 fw-bolder d-block fs-4">{refunds}</span>
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-2" />
                  <div className="d-flex justify-content-between">
                    <div>
                      <div className="d-flex justify-content-start flex-column">
                        <span className="text-gray-700 fw-bold mb-1 fs-7">Adv. Cost</span>
                        <span className={`fw-bolder d-block fs-4 ${adv_cost < 0 ? 'text-danger' : 'text-success'}`}>{selectedCurrencySign}{adv_cost.toFixed(2)}</span>
                      </div>
                    </div>
                    <div>
                      <div className="d-flex justify-content-start flex-column">
                        <span className="text-gray-700 fw-bold mb-1 fs-7">Est. payout</span>
                        <span className="text-gray-800 fw-bolder d-block fs-4">{selectedCurrencySign}{est_payout.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                  <div className="separator separator-dashed my-2" />
                  <div className="d-flex justify-content-between badge-light-success p-4 py-2">
                    <div>
                      <div className="d-flex justify-content-start flex-column">
                        <span className="text-gray-700 fw-bold mb-1 fs-7">Gross profit</span>
                        <span className="text-primary fw-bolder d-block fs-4">{selectedCurrencySign}{gross_profit?.toFixed(2) ?? '0.00'}</span>
                      </div>
                    </div>
                    <div>
                      <div className="d-flex justify-content-start flex-column">
                        <span className="text-gray-700 fw-bold mb-1 fs-7">Net profit</span>
                        <span className="text-primary fw-bolder d-block fs-4">{selectedCurrencySign}{net_profit.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <a href="#" onClick={(e) => { e.preventDefault(); showDrawer(tile); }} className="fw-bold fs-6 text-dark">More Details</a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <ItemMaster selectedTileData={selectedTileData} selectedMarketplace={selectedMarketplace} selectedCurrencySign={selectedCurrencySign} userData={userData}/>
      {/* Drawer Section */}
      <Drawer
        extra={
          <div>
            <div className=' text-end' style={{ fontWeight: 'bold' }}>{selectedTileData?.filter_name}</div>
            <div className='fs-6'>{selectedTileData?.start_date}</div>
          </div>
        }
        placement="right"
        onClose={closeDrawer}
        open={drawerVisible}
        width={400}
        >
  {selectedTileData?.more_data && (
      <Wrapper>
    <div className="tiles-details ">
      {/* Sales */}
      <Collapse bordered={false} >
        <Panel header={`Sales`} key="sales" extra={<span className="text-gray-800 fw-bold">{selectedCurrencySign}{selectedTileData?.more_data?.sales?.total}</span>}>
          {renderRow('Organic', selectedTileData.more_data.sales?.organic, false, selectedCurrencySign)}
          {renderRow('Sponsored Products (same day)', selectedTileData.more_data.sales?.sp_sales, false, selectedCurrencySign)}
          {renderRow('Sponsored Display (same day)', selectedTileData.more_data.sales?.sd_sales, false, selectedCurrencySign)}
        </Panel>
      </Collapse>

         {/* Sales */}
         <Collapse bordered={false} >
         <Panel header={`Units`} key="units" extra={<span className="text-gray-800 fw-bold">{selectedTileData?.more_data?.units?.total}</span>}>
          {renderNumberRow('Organic', selectedTileData.more_data.units?.organic)}
          {renderNumberRow('Sponsored Products (same day)', selectedTileData.more_data.units?.sp_units)}
          {renderNumberRow('Sponsored Display (same day)', selectedTileData.more_data.units?.sd_units)}
        </Panel>
      </Collapse>

      {/* Promo */}
      {renderMainRow('Promo', selectedTileData.more_data.promo, false, selectedCurrencySign)}


      {/* Advertising Cost */}
      <Collapse bordered={false}>
        <Panel header="Advertising cost" key="adv_cost" extra={<span className="text-gray-800 fw-bold">{selectedCurrencySign}{selectedTileData?.more_data?.advertising_cost?.total}</span>}>
          {/* {Object.entries(selectedTileData.more_data.advertising_cost).map(([k, v]) =>
            renderRow(k.replace(/_/g, ' '), v)
          )} */}
            {renderRow('Sponsored Products', selectedTileData.more_data.advertising_cost?.sp_cost, false, selectedCurrencySign)}
            {renderRow('Sponsored Brands', selectedTileData.more_data.advertising_cost?.sd_cost, false, selectedCurrencySign)}
            {renderRow('Sponsored Brands Video', selectedTileData.more_data.advertising_cost?.sbv_cost, false, selectedCurrencySign)}
            {renderRow('Sponsored Display', selectedTileData.more_data.advertising_cost?.sd_cost, false, selectedCurrencySign)}
        </Panel>
      </Collapse>

      {/* Promo */}
      {renderMainRow('Gift Wrap', selectedTileData.more_data.giftwrap, false, selectedCurrencySign)}


      {/* Shipping Costs */}
      <Collapse bordered={false}>
        <Panel header="Shipping costs" key="shipping" extra={<span className="text-gray-800 fw-bold">{selectedCurrencySign}{selectedTileData?.more_data?.shipping_cost?.total}</span>}>
          {renderRow('FBM shipping cost', selectedTileData.more_data.shipping_cost?.fba_shipping_chargeback, false, selectedCurrencySign)}
        </Panel>
      </Collapse>

      {/* Refund Cost */}
      <Collapse bordered={false}>
        <Panel header="Refund cost" key="refund_cost" extra={<span className="text-gray-800 fw-bold">{selectedCurrencySign}{selectedTileData?.more_data?.refund_cost?.total}</span>}>
        {Object.entries(selectedTileData.more_data.refund_cost)
          .filter(([key]) => key !== 'total')
          .map(([k, v]) => renderRow(k.replace(/_/g, ' '), parseFloat(v), false, selectedCurrencySign))}
        </Panel>
      </Collapse>

      {/* Amazon Fees */}
      <Collapse bordered={false}>
        <Panel header="Amazon fees" key="amazon_fees" extra={<span className="text-gray-800 fw-bold">{selectedCurrencySign}{selectedTileData?.more_data?.amazon_fees?.total}</span>}>
       
          {Object.entries(selectedTileData.more_data.amazon_fees)
          .filter(([key]) => key !== 'total')
          .map(([k, v]) => renderRow(k.replace(/_/g, ' '), parseFloat(v), false, selectedCurrencySign))}
        </Panel>
      </Collapse>

      {/* Cost of Goods */}
      <Collapse bordered={false}>
        <Panel header="Cost of goods" key="cogs" extra={<span className="text-gray-800 fw-bold">{selectedCurrencySign}{selectedTileData?.more_data?.cost_of_goods?.total}</span>}>
          {Object.entries(selectedTileData.more_data.cost_of_goods)
            .filter(([key]) => key !== 'total')
            .map(([k, v]) => renderRow(k.replace(/_/g, ' '), parseFloat(v), false, selectedCurrencySign))}
        </Panel>
      </Collapse>

      {/* VAT */}
      {renderMainRow('VAT', selectedTileData.more_data.vat, false, selectedCurrencySign)}

      {/* Gross Profit */}
      {renderMainRow('Gross profit', selectedTileData.more_data.gross_profit, false, selectedCurrencySign)}

      {/* Expenses */}
      <Collapse bordered={false}>
        <Panel header="Expenses" key="expenses" extra={<span className="text-gray-800 fw-bold">{selectedCurrencySign}{selectedTileData?.more_data?.expenses?.total}</span>}>
          {Object.entries(selectedTileData.more_data.expenses)
            .filter(([key]) => key !== 'total')
            .map(([k, v]) => renderRow(k.replace(/_/g, ' '), parseFloat(v), false, selectedCurrencySign))}
        </Panel>
      </Collapse>

      {/* Totals */}
      {renderMainRow('Net profit', selectedTileData.more_data.net_profit, true, selectedCurrencySign)}
      {renderMainRow('Estimated payout', selectedTileData.more_data.estimated_payout, false, selectedCurrencySign)}
      {renderMainRow('Real ACOS', `${selectedTileData.more_data.real_acos}%`)}
      {renderMainRow('% Refunds', `${selectedTileData.more_data.refunds_percent}%`)}
      {renderMainRow('Sellable returns', `${selectedTileData.more_data.sellable_returns}%`)}
      {renderMainRow('Margin', `${selectedTileData.more_data.margin}%`)}
      {renderMainRow('ROI', `${selectedTileData.more_data.roi}%`)}
      {renderMainRow('Active subscriptions (SnS)', `${selectedTileData.more_data.active_subscriptions}%`)}

       {/* Expenses */}
       <Collapse bordered={false}>
        <Panel header="Sessions" key="sessions" extra={<span className="text-gray-800 fw-bold">{selectedTileData?.more_data?.sessions?.total}</span>}>
          {Object.entries(selectedTileData.more_data.sessions)
            .filter(([key]) => key !== 'total')
            .map(([k, v]) => renderRow(k.replace(/_/g, ' '), v))}
        </Panel>
      </Collapse>

      {renderMainRow('Unit session percentage', `${selectedTileData.more_data.unit_session_percent}%`)}

    </div>
  </Wrapper>
  )}
</Drawer>
    </Wrapper>
  );
};

export default Tiles;
